import { END_POINTS } from '../constants/urls';
import emptySplitApi from '../utils/rtk';

interface CommonResponseType {
    statusCode: number;
    message: string;
}

export const userApi = emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
        addUser: builder.mutation<CommonResponseType, any>({
            query: (body) => ({
                url: END_POINTS.addUser,
                method: "POST",
                body,
            }),
        }),
        getUserList: builder.query<
            CommonResponseType & {
                data: {
                    list: any[];
                    totalCount: number;
                };
            },
            {
                page: number;
                limit: number;
                search?: string;
                isBlocked?: string;
                userType?: string;
                dateFrom?: string;
                dateTo?: string;
            }

        >({
            query: ({ page, limit, search, isBlocked, userType, dateFrom, dateTo }) => ({
                url: `${END_POINTS.users}?page=${page}&limit=${limit}${search ? `&search=${search}` : ""}${isBlocked !== '0' ? `&isBlocked=${isBlocked === '2' ? true : false}` : ""}${userType && userType !== '0' ? `&userType=${userType}` : ""}${dateFrom ? `&dateFrom=${dateFrom}` : ""}${dateTo ? `&dateTo=${dateTo}` : ""}`,
                method: 'GET',

            }),
        }),
        getUsersById: builder.query<
            CommonResponseType & { data: any },
            { id: string }
        >({
            query: ({ id }) => ({
                url: `${END_POINTS.addUser}/${id}`,
                method: "GET",
            }),
        }),
        exportUsers: builder.query<
            CommonResponseType & { data: any },
            { }
        >({
            query: () => ({
                url: `${END_POINTS.usersExport}`,
                method: "GET",
            }),
        }),
        getUserTransactions: builder.query<
            CommonResponseType & { data: any },
            { id: string }
        >({
            query: ({ id }) => ({
                url: `${END_POINTS.usersTransactions}/?userId=${id}`,
                method: "GET",
            }),
        }),
        updateUsersById: builder.mutation<
        CommonResponseType & { data: any },
        { body: any, id: string }
        >({
            query: ({ body, id }) => ({
                url: `${END_POINTS.addUser}/${id}`,
                method: "PUT",
                body
            }),
        }),
        deleteUsersById: builder.mutation<
            CommonResponseType & { data: any },
            { id: string }
        >({
            query: ({ id }) => ({
                url: `${END_POINTS.addUser}/${id}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const {
    useLazyGetUserListQuery,
    useAddUserMutation,
    useGetUserListQuery,
    useGetUsersByIdQuery,
    useLazyExportUsersQuery,
    useGetUserTransactionsQuery,
    useUpdateUsersByIdMutation,
    useDeleteUsersByIdMutation
} = userApi;
